module.exports = __webpack_public_path__ + "static/cg_role_153_0015cf32d15.wav";